<template>
  <div v-if="pieChartData">
    <md-card class="pb-10">
      <div class="md-layout">
        <p
          class="pt-5 pb-3 text-lg md-layout-item md-size-100 font-medium text-xl"
        >
          {{ $t("assignment_overall.toefl_total_score") }}
        </p>
        <div class="md-layout-item md-size-40">
          <p class="pb-5 ">
            {{
              $t(
                "assignment_overall.graph_percentage_of_toefl_total_score_range"
              )
            }}
          </p>
          <pie-chart
            v-if="chartData"
            key="chartData"
            :chart-data="chartData"
            :tooltips-callback-cfg="tooltipsCallbackCfg"
            :legendCfg="{
              position: 'bottom'
            }"
          ></pie-chart>
        </div>
        <div class="md-layout-item md-size-50">
          <p class="pb-5 ">
            {{ $t("assignment_overall.detailed_figures") }}
          </p>
          <md-table class="detail-piechart">
            <md-table-head
              ><span class="text-white">{{
                $t("assignment_overall.score_range")
              }}</span></md-table-head
            >
            <md-table-head
              ><span class="text-white">{{
                $t("assignment_overall.percentage")
              }}</span></md-table-head
            >
            <md-table-head
              ><span class="text-white">
                {{ $t("assignment_overall.number_of_students_achieved") }}
              </span></md-table-head
            >
            <template v-if="label">
              <md-table-row v-for="(item, index) in label" :key="index + item">
                <md-table-cell class="text-center">{{ item }}</md-table-cell>
                <md-table-cell class="text-center">
                  {{
                    parseFloat(((data[index] / sum) * 100).toFixed(3))
                  }}%</md-table-cell
                >
                <md-table-cell class="text-center">{{
                  data[index]
                }}</md-table-cell>
              </md-table-row>
            </template>
          </md-table>
        </div>
      </div>
    </md-card>
  </div>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import { COLOR_PIE_CHART_TOEFL_OVERALL } from "@/helpers/color-chart-config";

export default {
  components: { PieChart },
  props: ["pieChartData"],
  data() {
    return {
      label: null,
      data: [],
      sum: null,
      tooltipsCallbackCfg: {
        title: {
          prefix: "Score"
        },
        label: true,
        afterLabel: {
          subfix: "students"
        }
      }
    };
  },
  computed: {
    chartData() {
      return this.generateGenderChart(this.pieChartData);
    }
  },
  methods: {
    generateGenderChart(pieChartData) {
      if (!pieChartData) return null;
      this.label = pieChartData.label;
      this.data = pieChartData.data;
      this.sum = this.data.reduce((partialSum, a) => partialSum + a, 0);
      return {
        labels: this.label.reverse(),
        datasets: [
          {
            data: this.data.reverse(),
            backgroundColor: this.label.map(
              label => COLOR_PIE_CHART_TOEFL_OVERALL[label]
            ),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.detail-piechart {
  .md-table-head {
    background-color: #e39157;
  }
}
.md-table-head {
  padding: 12px 8px;
  text-align: center;
  border: 0.5px solid #b8b7b7;
}
.md-table-cell {
  border: 0.5px solid #b8b7b7;
}
</style>
